export abstract class ClientService {
  protected log(msg: unknown, ...extra: any[]) {
    console.log(`[${this.constructor.name}]:`, msg, ...extra);
  }
  protected trace(msg: unknown, ...extra: any[]) {
    console.trace(`[${this.constructor.name}]:`, msg, ...extra);
  }
  protected warn(msg: unknown, ...extra: any[]) {
    console.warn(`[${this.constructor.name}]:`, msg, ...extra);
  }
  protected error(msg: unknown, ...extra: any[]) {
    console.error(`[${this.constructor.name}]:`, msg, ...extra);
  }
}
